// src/components/cursos/FiltrosEstadoCursos.jsx
import PropTypes from 'prop-types';
import { Box, Stack } from '@mui/material';
import ItemEstadoCurso from './ItemEstadoCurso';

const FiltrosEstadoCursos = ({ cursos, cursoFiltro, setCursoFiltro }) => {
    const totalSinComenzar = cursos.filter((x) => x.numCalif == 0 && x.isAprobado == 0).length;

    const totalEnProceso = cursos.filter((x) => x.isAprobado == 0 && x.numCalif > 0).length;

    const totalCompletados = cursos.filter((x) => x.isAprobado == 1).length;

    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                mb: 2
            }}
        >
            <Stack
                direction="row"
                spacing={2}
                justifyContent="center"
                alignItems="center"
                sx={{
                    flexWrap: 'wrap'
                }}
            >
                <ItemEstadoCurso
                    color="#EF9A9A"
                    num={totalSinComenzar}
                    msj="Sin comenzar"
                    tipoIcono="sin_comenzar"
                    selected={cursoFiltro === 0}
                    onClick={() => setCursoFiltro(cursoFiltro === 0 ? null : 0)}
                />

                <ItemEstadoCurso
                    color="#FFF59D"
                    num={totalEnProceso}
                    msj="En proceso"
                    tipoIcono="en_proceso"
                    selected={cursoFiltro === 2}
                    onClick={() => setCursoFiltro(cursoFiltro === 2 ? null : 2)}
                />

                <ItemEstadoCurso
                    color="#69F0AE"
                    num={totalCompletados}
                    msj="Completados"
                    tipoIcono="completado"
                    selected={cursoFiltro === 1}
                    onClick={() => setCursoFiltro(cursoFiltro === 1 ? null : 1)}
                />
            </Stack>
        </Box>
    );
};

FiltrosEstadoCursos.propTypes = {
    cursos: PropTypes.array,
    cursoFiltro: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
    setCursoFiltro: PropTypes.func
};

FiltrosEstadoCursos.defaultProps = {
    cursos: [],
    cursoFiltro: null,
    setCursoFiltro: () => {}
};

export default FiltrosEstadoCursos;
